import React, { useContext, useEffect, useState } from 'react';
import I18n from 'i18n-js';
import Modal from '@reverbdotcom/commons/src/components/modal';
import { RCButton } from '@reverbdotcom/cadence/components';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import BumpV2ModalContainer, {
  BumpV2ModalContainerProps,
} from '../../bump/bump_v2_modal_container';
import {
  bumpRecommendationsController,
  BumpControllerProps,
} from '../../bump/bump_controller';
import { formatBid } from '../../bump/bump_helpers';
import SellerListingCardContext from '../SellerListingCardContext';
import { ActionType } from '../sellerListingCardReducer';

export const COMPONENT_NAME = 'ListingRowBumpButtonV2';

export function ListingRowBumpButtonV2(props: BumpV2ModalContainerProps) {
  const [showModal, setShowModal] = useState(false);

  const { cardState, dispatch } = useContext(
    SellerListingCardContext,
  );

  function handleClick() {
    setShowModal(true);
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId: cardState.listing.id,
    });
  }

  useEffect(() => {
    if (props.successMessage) {
      const message = props.bid
        ? I18n.t('discovery.bump.successListingRow', {
          percent: formatBid(props.bid),
        })
        : I18n.t('discovery.bump.successBidDelete');
      
      dispatch({
        type: ActionType.SHOW_TOAST,
        payload: {
          isSuccess: true,
          message,
        },
      });

      dispatch({
        type: ActionType.SET_LISTING,
        payload: {
          listing: { ...cardState.listing, bumpRate: { rate: formatBid(props.bid) } },
        },
      });
    }
  }, [props.successMessage]);

  return (
    <>
      <RCButton variant="tertiary" onClick={handleClick} fullWidth>
        {I18n.t('discovery.bumpModalV2.buttonListingRow')}
      </RCButton>
      <Modal
        isOpen={showModal}
        headerTitle={I18n.t('discovery.bumpModalV2.modal.title')}
        onRequestClose={() => {
          setShowModal(false);
        }}
        paddedBody
        shouldCloseOnOverlayClick
      >
        <BumpV2ModalContainer
          bid={props.bid}
          listingId={props.listingId}
          selectedBid={props.selectedBid}
          handleBidChange={props.handleBidChange}
          updateBid={props.updateBid}
          successMessage={props.successMessage}
          failMessage={props.failMessage}
          refetch={() => {}}
          onRequestClose={() => {
            setShowModal(false);
          }}
        />
      </Modal>
    </>
  );
}

const ListingRowBumpButtonContainerV2 =
  bumpRecommendationsController(ListingRowBumpButtonV2);

export default (props: BumpControllerProps) => {
  return (
    <ListingRowBumpButtonContainerV2
      componentName={COMPONENT_NAME}
      listingId={props.listingId}
      bid={props.bid}
      refetch={() => {}}
    />
  );
};
